export const PARTNER_PROFILE_UPDATE_STATE = "PARTNER_PROFILE_UPDATE_STATE";

export default (state = null, action) => {
    switch (action.type) {
        case PARTNER_PROFILE_UPDATE_STATE:
            return action.payload;
        default:
            return state;
    }
}
